import * as prismic from '@prismicio/client';

// Fill in your repository name
export const repositoryName = 'phio';
const endpoint = prismic.getEndpoint(repositoryName);

export const client = prismic.createClient(endpoint, {
    // If your repo is private, add an access token
    accessToken: '',

    // This defines how you will structure URL paths in your project.
    // Update the types to match the Custom Types in your project, and edit
    // the paths to match the routing in your project.
    //
    // If you are not using a router in your project, you can change this
    // to an empty array or remove the option entirely.
    routes: [
        {
            type: 'cookie_page',
            path: '/cookie',
        },
        {
            type: 'terms_page',
            path: '/terms',
        },
        {
            type: 'privacy_page',
            path: '/privacy',
        },
        {
            type: 'engage_privacy',
            path: '/engage/privacy',
        },
        {
            type: 'engage_privacy',
            path: '/engage/privacy-aus',
        },
        {
            type: 'engage_terms',
            path: '/engage/terms',
        },
        {
            type: 'engage_terms',
            path: '/engage/terms-aus',
        },
        {
            type: 'faq_page',
            path: '/faq/access',
        },
        {
            type: 'faq_page',
            path: '/faq/engage',
        },
    ],
});
